module.exports = __webpack_public_path__ + "static/media/iphone_14_silver_pro_max.3458aa4b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/iphone/iphone_14_silver_pro_max.jpg
// module id = 2136
// module chunks = 0